// importing actions
import {START_FETCH_CONTACT_NOTES, SUCCESS_FETCH_CONTACT_NOTES, FAILED_FETCH_CONTACT_NOTES} from './actions/fetchContactNotes'

import {START_ADD_CONTACT_NOTES, SUCCESS_ADD_CONTACT_NOTES, FAILED_ADD_CONTACT_NOTES} from './actions/addContactNotes'

import {START_UPDATE_CONTACT_NOTES, SUCCESS_UPDATE_CONTACT_NOTES, FAILED_UPDATE_CONTACT_NOTES} from './actions/addContactNotes'

import {START_DELETE_CONTACT_NOTES, SUCCESS_DELETE_CONTACT_NOTES, FAILED_DELETE_CONTACT_NOTES} from './actions/deleteContactNotes'

export default function contactNotes(state, action){
  switch(action.type){

    // Fetching
    case START_FETCH_CONTACT_NOTES: {
      return {...state, ...action.payload}
    }
    case SUCCESS_FETCH_CONTACT_NOTES: {
      return {...state, ...action.payload}
    }
    case FAILED_FETCH_CONTACT_NOTES: {
      const {error, fetching, hasPermission} = action.payload

      return {...state, error, hasPermission, fetching}
    }

    // Adding
    case START_ADD_CONTACT_NOTES: {
      const { params } = action.payload;
      return {...state}
    }
    case SUCCESS_ADD_CONTACT_NOTES: {
      return {...state}
    }
    case FAILED_ADD_CONTACT_NOTES: {
      return {...state, err: action.payload}
    }

    // deleting
    case START_DELETE_CONTACT_NOTES: {
      const { index } = action.payload;

      return {
        ...state,
        result_list: [
          ...state.result_list.slice(0, index),
          ...state.result_list.slice(index + 1)
        ]
      }
    }

    // Updating
    case START_UPDATE_CONTACT_NOTES: {
      const { params } = action.payload;
      return {...state}
    }
    case SUCCESS_UPDATE_CONTACT_NOTES: {
      return {...state}
    }
    case FAILED_UPDATE_CONTACT_NOTES: {
      return {...state, err: action.payload}
    }




    default: return {...state}
  }
}



// WEBPACK FOOTER //
// ./src/template/Docks/ContactInfo/ContactNotes/redux/reducer.js